if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends ModalDialog {
      constructor() {
        super();

        this.content = this.querySelector('.quick-view-content');
        this.gallery = this.querySelector('images-slider');
      }

      open() {
        this.loadProduct();
        super.open();
      }

      loadProduct() {
        const handle = this.getAttribute('handle');
        if (!handle) {
          return;
        }

        this.content.style.display = 'none';
        this.classList.add('loading');
        this.classList.remove('loaded');

        fetch(window.Shopify.routes.root + 'products/' + handle + '?section_id=quick-view')
          .then((response) => response.text())
          .then((responseText) => {
            this.renderContent(responseText);
          })
          .catch((e) => {
            console.error(e);
          });
      }

      renderContent(content) {
        this.classList.remove('loading');
        this.classList.add('loaded');
        this.content.innerHTML = content;
        this.content.style.removeProperty('display');
      }
    }
  );
}

if (!customElements.get('quick-view')) {
  customElements.define(
    'quick-view',
    class QuickView extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('[data-handle]');
        this.modal = document.querySelector('quick-view-modal');

        if (this.button) {
          this.button.addEventListener('click', this.showModal.bind(this));
        }
      }

      showModal(e) {
        if (!this.modal) {
          return;
        }

        e.preventDefault();

        this.modal.setAttribute('handle', this.button.dataset.handle);
        this.modal.open();
      }
    }
  );
}

if (!customElements.get('quick-view-opener')) {
  customElements.define(
    'quick-view-opener',
    class QuickViewOpener extends HTMLElement {
      constructor() {
        super();

        this.modal = document.querySelector('quick-view-modal');
        this.addEventListener('click', this.showModal.bind(this));
      }

      showModal(e) {
        if (!this.modal || this.hasAttribute('disabled')) {
          return;
        }

        e.preventDefault();

        const handle = this.getAttribute('handle');
        if (handle) {
          this.modal.setAttribute('handle', handle);
          this.modal.open();
        }
      }
    }
  );
}
